import styled from 'styled-components';

export const TableFooter = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;